import { render } from "./BuffetPage.vue?vue&type=template&id=307577b6"
import script from "@/service/BuffetPage.js?vue&type=script&lang=js&external"
export * from "@/service/BuffetPage.js?vue&type=script&lang=js&external"

import "../css/buffet.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__